var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    !_vm.blockSmallViewport
      ? _c(
          "div",
          [
            _c("CinematicLoader", { attrs: { loading: _vm.bootLoading } }),
            !_vm.bootLoading && _vm.usuarioAtual.id_interno
              ? _c(
                  "Layout",
                  [_c("RouterView", { key: _vm.chaveDeMontagem })],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm.blockSmallViewport
      ? _c(
          "div",
          {
            staticClass: "v-application text-center p-20",
            staticStyle: {
              height: "100vh",
              width: "100%",
              display: "flex",
              "flex-direction": "column",
              "align-items": "center",
              "justify-content": "center"
            }
          },
          [
            _c(
              "v-btn",
              {
                staticStyle: {
                  position: "fixed",
                  top: "20px",
                  right: "20px",
                  padding: "20px"
                },
                attrs: { icon: "" },
                on: {
                  click: function($event) {
                    _vm.showAlertSize = false
                  }
                }
              },
              [_c("icon-svg", { attrs: { name: "close", color: "primary" } })],
              1
            ),
            _c(
              "v-icon",
              {
                staticStyle: { "font-size": "70px" },
                attrs: { color: "primary" }
              },
              [_vm._v(" mdi-monitor ")]
            ),
            _c(
              "p",
              {
                staticClass: "mt-10",
                staticStyle: { "margin-bottom": "30px" }
              },
              [
                _vm._v(
                  " Para ter uma experiência melhor, acesse a plataforma por um computador. "
                )
              ]
            ),
            _c(
              "BaseButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function($event) {
                    _vm.showAlertSize = false
                  }
                }
              },
              [_vm._v(" Fechar Aviso ")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }